import React from 'react';
import { motion } from 'framer-motion';
import { Mountain, Warehouse, Ban, Sun, Shield, Maximize } from 'lucide-react';
const features = [{
  icon: Mountain,
  title: 'Foothills Location',
  description: 'Elevated lot with panoramic mountain views and stunning desert sunsets.'
}, {
  icon: Warehouse,
  title: 'Detached Workshop',
  description: 'Massive climate-controlled garage for RVs, collections, or creative work.'
}, {
  icon: Ban,
  title: 'No HOA',
  description: 'True ownership freedom. No restrictive covenants or monthly fees.'
}, {
  icon: Maximize,
  title: 'Over an Acre of Land',
  description: 'Expansive usable land with room for expansion or animals.'
}, {
  icon: Shield,
  title: 'Ultimate Privacy',
  description: 'Set back from the road, offering seclusion without isolation.'
}, {
  icon: Sun,
  title: 'Outdoor Living',
  description: 'Designed for the Arizona lifestyle with covered patios and a pool designed to entertain.'
}];
export function PropertyOverview() {
  return <section id="overview" className="py-20 bg-[#FAF8F5]" data-id="element-165">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D2D2D] mb-4" data-id="element-168">
            Not Just a Home, A Lifestyle
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-169">
            Escape the cramped subdivisions. This property offers the rare
            combination of luxury living and functional freedom.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-170">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300" data-id="element-171">
              <div className="w-12 h-12 bg-[#E8DCC4] rounded-full flex items-center justify-center mb-6 text-[#C1694F]" data-id="element-172">
                <feature.icon size={24} strokeWidth={1.5} data-id="element-173" />
              </div>
              <h3 className="text-xl font-serif font-semibold text-[#2D2D2D] mb-3" data-id="element-174">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-175">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}